const SendMoney2Icon = () => {
  return (
    <svg fill="none" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25.6668 16.3333V11.6667C25.6668 10.1939 24.4729 9 23.0002 9H9.00016C7.5274 9 6.3335 10.1939 6.3335 11.6667V20.3333C6.3335 21.8061 7.5274 23 9.00016 23H25.6668M25.6668 23L23.6668 21M25.6668 23L23.6668 25.3333M19.0002 16C19.0002 18.3932 17.657 20.3333 16.0002 20.3333C14.3433 20.3333 13.0002 18.3932 13.0002 16C13.0002 13.6068 14.3433 11.6667 16.0002 11.6667C17.657 11.6667 19.0002 13.6068 19.0002 16Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  )
}

export default SendMoney2Icon
